// extracted by mini-css-extract-plugin
var _1 = "current-page-button--QCCKo";
var _2 = "page-info--WzCP8";
var _3 = "page-size-container--AeTDp";
var _4 = "page-size-label--LxvL1";
var _5 = "page-size-select--tD8pk";
var _6 = "pagination-button--y54ef";
var _7 = "pagination-buttons-container--uxRXG";
var _8 = "pagination-container--iTVSF";
var _9 = "pagination-controls--WXzFu";
export { _1 as "current-page-button", _2 as "page-info", _3 as "page-size-container", _4 as "page-size-label", _5 as "page-size-select", _6 as "pagination-button", _7 as "pagination-buttons-container", _8 as "pagination-container", _9 as "pagination-controls" }
